import { render, staticRenderFns } from "./ItemUpdateDialogDescription.vue?vue&type=template&id=23b3b1d2&scoped=true"
import script from "./ItemUpdateDialogDescription.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3b1d2",
  null
  
)

export default component.exports